import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import NavBar from './components/NavBar';
import Login from './components/Login';
import SignUp from './components/Signup';
import { ErrorProvider } from './components/ErrorContext';
import Tag from './components/Tag';
import Question from './components/Question';
import PassageGroupManagement from './components/PassageGroupManagement';
import Quiz from './components/Quiz';
import Home from './components/Home';
import UserQuiz from './components/UserQuiz';
import FavoriteQuestionsGrid from './components/FavoriteQuestionsGrid';
import ReportedQuestionsGrid from './components/ReportedQuestionGrid';
import UserStatistics from './components/UserStatistics';
import AboutPage from './components/About';
import ContactPage from './components/ContactUs';
import AdminRoute from './components/AdminRoute';
import SuperAdminRoute from './components/SuperAdminRoute';
import SessionManager from './components/SessionManager';
import UnauthorizedPage from './components/Unauthorize';
import NotFoundPage from './components/NotFound';
import CommentGridPage from './components/CommentGrid';
import PremiumPage from './components/Premium';
import IngestionPage from './components/ingestion/IngestionPage';
import AdminRevisionInbox from './components/AdminRevisionInbox';
import AutoQuizBuild from './components/AutoQuizBuild';
import VocabularyStore from './components/vocabulary/VocabularyStore';
import VocabularyManagement from './components/vocabulary/VocabularyManagement';
import AdminManagement from './components/superadmin/AdminManagement';
import PromoCodeManagement from './components/superadmin/PromoCodeManagement';
import AwardManagement from './components/superadmin/AwardManagement';
import UserManagement from './components/superadmin/UserManagement';
import ReferralDashboard from './components/superadmin/ReferralDashboard';
import PaymentsDashboard from './components/superadmin/PaymentsDashboard';
import RewardsManagement from './components/superadmin/RewardsManagement';
import ReferAFriend from './components/ReferAFriend';
import RewardsEarned from './components/RewardsEarned';
import Footer from './components/Footer';
import ProfileSettings from './components/ProfileSettings';
import NoticeManagement from './components/NoticeManagement';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import MyNotifications from './components/MyNotifications';
import PaymentManagement from './components/PaymentManagement';
import ManageSubscription from './components/ManageSubscription';
import SubscriptionDetail from './components/SubscriptionDetail';
import MockGateway from './components/MockGateway';
import SubscriptionResult from './components/SubscriptionResult';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import VerifyEmail from './components/VerifyEmail';
import EmailVerifyBanner from './components/EmailVerifyBanner';
import CompetitionNoticeBanner from './components/CompetitionNoticeBanner';
import GlobalLoadingIndicator from './components/GlobalLoadingIndicator';
import { ImageViewerProvider } from './components/ImageViewer';
import { NotificationProvider } from './contexts/NotificationContext';
import ScrollToTop from './components/ScrollToTop';

function App() {

  return (
    <ErrorProvider>
      <ImageViewerProvider>
        <Router>
        <NotificationProvider>
          <ScrollToTop />
          <GlobalLoadingIndicator />
          <NavBar title="Kobra Prep" />
          <SessionManager />
          <EmailVerifyBanner />
          <CompetitionNoticeBanner />
          <Routes>
            <Route path="/signup" element={<SignUp />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/tag" element={<AdminRoute><Tag /></AdminRoute>} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/" element={<PremiumPage />} />
            <Route path="/question" element={<AdminRoute><Question /></AdminRoute>} />
            <Route path="/passages" element={<AdminRoute><PassageGroupManagement /></AdminRoute>} />
            <Route path="/quiz" element={<AdminRoute><Quiz /></AdminRoute>} />
            <Route path="/auto-quiz-build" element={<AdminRoute><AutoQuizBuild /></AdminRoute>} />
            <Route path="/userquiz" element={<UserQuiz />} />
            <Route path="/vocabulary" element={<VocabularyStore />} />
            <Route path="/admin/vocabulary" element={<AdminRoute><VocabularyManagement /></AdminRoute>} />
            <Route path="/favorite" element={<FavoriteQuestionsGrid />} />
            <Route path="/reported" element={<AdminRoute><ReportedQuestionsGrid /></AdminRoute>} />
            <Route path="/comment" element={<AdminRoute><CommentGridPage /></AdminRoute>} />
            <Route path="/notices" element={<AdminRoute><NoticeManagement /></AdminRoute>} />
            <Route path="/admin/ingest" element={<AdminRoute><IngestionPage /></AdminRoute>} />
            <Route path="/revisions" element={<AdminRoute><AdminRevisionInbox /></AdminRoute>} />
            <Route path="/super-admin" element={<SuperAdminRoute><AdminManagement /></SuperAdminRoute>} />
            <Route path="/promo-code-management" element={<SuperAdminRoute><PromoCodeManagement /></SuperAdminRoute>} />
            <Route path="/award-management" element={<SuperAdminRoute><AwardManagement /></SuperAdminRoute>} />
            <Route path="/user-management" element={<SuperAdminRoute><UserManagement /></SuperAdminRoute>} />
            <Route path="/referral-dashboard" element={<SuperAdminRoute><ReferralDashboard /></SuperAdminRoute>} />
            <Route path="/payments-dashboard" element={<SuperAdminRoute><PaymentsDashboard /></SuperAdminRoute>} />
            <Route path="/rewards-management" element={<SuperAdminRoute><RewardsManagement /></SuperAdminRoute>} />
            <Route path="/stat" element={<UserStatistics />} />

            {/* Profile dropdown destinations */}
            <Route path="/profile" element={<ProfileSettings />} />
            <Route path="/change-password" element={<ProfileSettings />} />
            <Route path="/rewards" element={<RewardsEarned />} />
            <Route path="/subscription" element={<ManageSubscription />} />
            <Route path="/subscription/mock-gateway" element={<MockGateway />} />
            <Route path="/subscription/result" element={<SubscriptionResult />} />
            <Route path="/subscription/:planCode" element={<SubscriptionDetail />} />
            <Route path="/refer" element={<ReferAFriend />} />
            <Route path="/payments" element={<PaymentManagement />} />
            <Route path="/notifications" element={<MyNotifications />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />

            <Route path="/unauthorized" element={<UnauthorizedPage />} />

            {/* Catch-all 404 route */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <Footer />
        </NotificationProvider>
      </Router>
      </ImageViewerProvider>
    </ErrorProvider>
  );
}

export default App;
